import { useTranslation } from "@ncino/pax-ui";
import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/shared/components/PageHeader";
import { QuestionIcon } from "@phosphor-icons/react";

export const Route = createFileRoute("/help/")({
  staticData: { breadcrumb: { title: ({ t }) => t("breadcrumbs.help"), icon: QuestionIcon } },
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation("help");

  return <PageHeader title={t("helpPage.title")} />;
}
